import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Error = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:767px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        width: "100%",
        minHeight: "80vh",
        alignItems: "center",
        justifyContent: "center",
        gap: "2rem",
        padding: isMobile ? "1rem" : "none",
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontSize: "1.5rem", fontWeight: "bold" }}
      >
        We couldn't locate the page you requested.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/")}
        size="small"
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default Error;
